// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import injector from 'vue-inject';
import vueTabs from 'vue-nav-tabs';
import flatPickr from 'vue-flatpickr-component';
import moment from 'moment';
import * as VueMenu from '@hscmap/vue-menu';
import VueImg from 'v-img';
import '../node_modules/vue-snotify/styles/material.css';
import '../node_modules/vue-nav-tabs/themes/vue-tabs.css';
import '../node_modules/vue-nav-tabs/themes/material.css';
import '../node_modules/font-awesome/css/font-awesome.css';
import '../node_modules/materialize-css/dist/css/materialize.css';
import '../node_modules/materialize-css/dist/js/materialize.min.js';
import './assets/css/google-material-icon.css';
import './assets/js/jquery.twism.js';
import 'flatpickr/dist/themes/material_blue.css';
import '../node_modules/fullcalendar/dist/fullcalendar.css';
import en from '@/i18n/en.json';
  
import App from './App';
import router from './router';
require('./services');

Vue.use(Vuex);
Vue.use(VueI18Next);
Vue.use(injector);
Vue.use(vueTabs);
Vue.use(flatPickr);
Vue.use(VueMenu);
Vue.use(VueImg);
Vue.use(injector);

Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop
  }
});

i18next.init({
  lng: 'en',
  resources: {
    en:{
      translation:en
    }
  }
});

const i18n = new VueI18Next(i18next);

Vue.config.productionTip = false

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n: i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js